import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private handlingUnauthorized = false;

  constructor(
    private authService: AuthService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // return next.handle(request).pipe(
    //   catchError((error: HttpErrorResponse) => {
    //     let errorMessage = 'Terjadi kesalahan yang tidak diketahui!';
    //     if (error.error instanceof ErrorEvent) {
    //       // Client-side errors
    //       errorMessage = `Error: ${error.error.message}`;
    //     } else {
    //       // Server-side errors
    //       if (error.status === 0) {
    //         errorMessage = 'Tidak dapat terhubung ke server. Harap periksa koneksi internet Anda.';
    //       } else if (error.error && error.error.message) {
    //         errorMessage = error.error.message;
    //       } else {
    //         errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    //       }
    //     }
    //     this.errorDialogService.open({
    //       title: 'Error',
    //       message: errorMessage
    //     });
    //     return throwError(() => new Error(errorMessage));
    //   })
    // );
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.shouldForceLogout(error)) {
          this.forceLogout();
        }

        return throwError(() => error);
      })
    );
  }

  private shouldForceLogout(error: HttpErrorResponse | unknown): boolean {
    const status = (error as any)?.status;
    if (status !== 401) return false;
    return Boolean(this.authService.getToken());
  }

  private forceLogout(): void {
    if (this.handlingUnauthorized) return;
    this.handlingUnauthorized = true;
    this.authService.logout('session_expired');
  }
}
